import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setChartData } from "../../../redux/features/auditTrail/auditTrailSlice";
import { getChartData, getDropdownData } from "../../../services/auditTrail";
import { errorMsg } from "../../../utils/vars";

export const useDropdownDataQuery = () =>
  useQuery({
    queryKey: ["audit-trail-dropdown"],
    queryFn: getDropdownData,
    refetchOnWindowFocus: false,
    retry: 1,
  });

export const useGenerateChartMutation = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["audit-trail-chart"],
    mutationFn: getChartData,
    onSuccess: (data) => dispatch(setChartData(data)),
    onError: (err) => toast.error(err?.response?.data?.message || errorMsg),
  });
};
